export default 'PRODUCT_ORDER_MODULE_VIEW'